<div class="bg">
    <div class="container">
        <div id='my-form-element'></div>
    </div>
    
    <app-get-in-touch-banner></app-get-in-touch-banner>
</div>

